<template>
  <!-- Thin wrapper over PrimeVue Card, the design system's public API for cards. Forwards every prop,
       event, and slot. Theming and defaults live in preset.js. Use this, not primevue/card. -->
  <Card v-bind="$attrs">
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps"
      />
    </template>
  </Card>
</template>

<script setup>
import Card from 'primevue/card';

defineOptions({ inheritAttrs: false });
</script>
